import React, { useState } from 'react';

const Footer: React.FC = () => {
  const [email, setEmail] = useState('');

  return (
    <footer style={{ background: '#1C1C1E' }}>

      {/* Main footer */}
      <div className="w-full px-[6vw] py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-8">

          {/* Left: Email signup */}
          <div className="flex flex-col justify-between">
            <div>
              <h3 className="text-white font-bold leading-tight mb-3" style={{ fontSize: 'clamp(1.6rem, 2.5vw, 2.2rem)' }}>
                Sign up for email<br />updates
              </h3>
              <p className="text-gray-400 text-sm mb-8">
                Keep up with product news and new countries as they launch
              </p>
              {/* Email input */}
              <div className="flex items-center gap-2 bg-[#2A2A2C] rounded-full px-4 py-1.5 max-w-sm">
                <input
                  type="email"
                  placeholder="Enter email address..."
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="flex-1 bg-transparent text-white text-sm placeholder-gray-500 outline-none py-1.5"
                />
                <button
                  className="flex items-center gap-2 transition text-white text-sm font-semibold px-4 py-2 rounded-full flex-shrink-0"
                  style={{ backgroundColor: '#ea3d05' }}
                >
                  Subscribe
                  <span className="w-6 h-6 bg-black rounded-full flex items-center justify-center text-white text-xs">›</span>
                </button>
              </div>
            </div>
          </div>

          {/* Middle: Links */}
          <div className="flex flex-col gap-8">
            <div className="grid grid-cols-2 gap-6">
              <div>
                <p className="text-gray-500 text-[11px] font-bold tracking-widest uppercase mb-3">Quick Links</p>
                <ul className="space-y-2">
                  <li><a href="#how-it-works" className="text-gray-300 hover:text-white text-sm transition">How It Works</a></li>
                  <li><a href="#faq" className="text-gray-300 hover:text-white text-sm transition">FAQ</a></li>
                </ul>
              </div>
              <div>
                <p className="text-gray-500 text-[11px] font-bold tracking-widest uppercase mb-3">Get the App</p>
                <ul className="space-y-2">
                  <li><a href="#download" className="text-gray-300 hover:text-white text-sm transition">Smile Africa for iOS</a></li>
                  <li><a href="#download" className="text-gray-300 hover:text-white text-sm transition">Smile Africa for Android</a></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Right: Download card */}
          <div className="flex items-stretch">
            <div className="rounded-2xl p-7 flex flex-col justify-between w-full min-h-[220px]" style={{ backgroundColor: '#ea3d05' }}>
              <div className="flex items-start justify-between mb-6">
                <p className="text-orange-100 text-[11px] font-bold tracking-widest uppercase">Download Now</p>
                <span className="w-8 h-8 rounded-full border border-white/40 flex items-center justify-center text-white text-lg leading-none">+</span>
              </div>
              <div>
                <h3 className="text-white font-bold leading-tight mb-8" style={{ fontSize: 'clamp(1.6rem, 2.2vw, 2.4rem)' }}>
                  Send Airtime<br />Home Today
                </h3>
                <a
                  href="#download"
                  className="inline-flex items-center gap-3 bg-black hover:bg-gray-900 transition text-white text-sm font-semibold px-5 py-3 rounded-full"
                >
                  Download the App
                  <span className="w-7 h-7 bg-white rounded-full flex items-center justify-center text-black text-base">›</span>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="w-full px-[6vw] py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-5">
            <a href="#top" className="text-gray-500 hover:text-white text-xs font-bold tracking-widest uppercase transition">Privacy Policy</a>
            <a href="#top" className="text-gray-500 hover:text-white text-xs font-bold tracking-widest uppercase transition">Terms of Service</a>
          </div>
          <p className="text-gray-600 text-xs tracking-wide">
            ©2026 SMILE AFRICA. ALL RIGHTS RESERVED.
          </p>
          {/* Social icons */}
          <div className="flex items-center gap-5">
            {/* Instagram */}
            <a href="#top" aria-label="Instagram" className="text-gray-400 hover:text-white transition">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            {/* Twitter/X */}
            <a href="#top" aria-label="Twitter" className="text-gray-400 hover:text-white transition">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.266 5.638 5.898-5.638zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            {/* LinkedIn */}
            <a href="#top" aria-label="LinkedIn" className="text-gray-400 hover:text-white transition">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
